import React from 'react';
import { AlertDictionaryDiscountBookmark } from 'interfaces/alert.model';
import i18n from 'i18next';
import { ROUTES } from 'config';
import { DiscountType } from 'interfaces';

export const getAlertBodyTextDiscount = ({
  discountType,
  discountBookmark,
  discountId,
  discountTitle,
}: {
  discountType: DiscountType;
  discountBookmark: AlertDictionaryDiscountBookmark;
  discountId?: number;
  discountTitle: string;
}) => {
  const p1 = i18n.t(
    ['alert', discountType, discountBookmark, 'body__p1'].join('.'),
  );

  const shouldHideCompanyName = discountBookmark === 'archive';

  const p2 = !shouldHideCompanyName ? (
    <a href={`${ROUTES.discountRoot}/${discountId}`}>
      &quot;{discountTitle}&quot;
    </a>
  ) : null;

  const p3 = i18n.t(
    ['alert', discountType, discountBookmark, 'body__p2'].join('.'),
  );

  return (
    <>
      {p1} {p2} {p3}
    </>
  );
};

export const getAlertTitleDiscount = ({
  discountType,
  discountBookmark,
}: {
  discountType: DiscountType;
  discountBookmark: AlertDictionaryDiscountBookmark;
}) => {
  return i18n.t(['alert', discountType, discountBookmark, 'title'].join('.'));
};
